/* Project Import will be here */
import { post, IRequest } from "./index";
import {
  IOrderUploadParams,
  IOrderHistoryDetailsParams,
  IOrderInvoiceParams,
  IOrderSummaryDetailsParams,
  IBulkOrderUploadParams,
  IOrderInvStatusUpdateParams,
  IValidateCart
} from "models/orderModels";
import { IOrderHistoryFilterParams } from "models/orderModels";
/* Project Import will be here */

export const orderUploadApi = (data: IOrderUploadParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/OrderUpload`,
    data
  };
  return post(request);
};

export const orderHistoryApi = (data: IOrderHistoryFilterParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/OrderView`,
    data
  };
  return post(request);
};

export const cancelOrderListApi = (data: IOrderHistoryFilterParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/CancelOrderView`,
    data
  };
  return post(request);
};

export const cancelOrderApi = (data) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/CancelOrder`,
    data
  };
  return post(request);
};

export const orderHistoryDetailsApi = (data: IOrderHistoryDetailsParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/OrderViewDetails`,
    data
  };
  return post(request);
};

export const orderConfirmRequestOTPApi = () => {
  const request: IRequest = {
    subUrl: `/SalesOrder/RequestOrderOTP`
  };
  return post(request);
};

export const orderConfirmValidateOTPApi = (data) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/ValidateOrderOTP`,
    data
  };
  return post(request);
};

export const getOrderInvoiceListApi = (data: IOrderInvoiceParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/OrderInvoice`,
    data
  };
  return post(request);
};

/* Get order summary qty list */
export const getOrderSummaryQtyListApi = (data: IOrderSummaryDetailsParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/OrderSummaryDetail`,
    data
  };
  return post(request);
};

/* Upload bulk order and relevant so bulk order */
export const bulkOrderUploadApi = (data: IBulkOrderUploadParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/BulkOrderUpload`,
    data
  };
  return post(request);
};

/* Get order pending invoice list */
export const getOrderPendingInvListApi = () => {
  const request: IRequest = {
    subUrl: `/SalesOrder/PendingOrderInvoice`
  };
  return post(request);
};

/* Update pending invoice as delivered */
export const updateInvDeliveredApi = (data: IOrderInvStatusUpdateParams) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/UpdateInvoiceStatus`,
    data
  };
  return post(request);
};

/* Validate the cart before add to cart to check if any FOC product added in the cart when requesting for NON FOC product, NON FOC to FOC */
export const validateCartForFocApi = (data: IValidateCart) => {
  const request: IRequest = {
    subUrl: `/SalesOrder/ValidateCart`,
    data
  };
  return post(request);
}